import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Table, Pagination, Input, Typography } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import ReusableSearchInput from '@/components/ReusableSearch';
import {
  get_device_control_system,
  add_device_control_system,
} from "../../../utils/api";
import MainCard from '@/components/MainCard';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/App';

const { Title } = Typography;
// Ant Design components are used instead of MUI

function DcsConfig({ show_table, addForm, set_get_status, get_status }) {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';
  const formRef = useRef();
  const [dcsData, setdcsData] = useState([]);
  const [unit, setUnits] = useState();
  const [show_form, set_show_form] = useState(false);
  const [searchvalue, setSearchvalue] = useState("");
  const [dcsReq, setdcsReq] = useState({
    name: "",
    description: "",
    ip_address: "",
    port: "",
    protocol: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dcsReq["dcs_name"] !== "") {
      add_dcs(dcsReq);
    } else {
      toast.warning("Please Enter All the Details");
    }
  };

  // table columns
  const dcsDetailColumns = [
    {
      dataIndex: "dcs_name",
      title: "Name",
      key: "name",
      width: "15%",
      align: "center",
    },
    {
      dataIndex: "description",
      title: "Description",
      key: "description",
      width: "25%",
      align: "center",
    },
    {
      dataIndex: "ip_address",
      title: "IP Address",
      key: "ip_address",
      width: "15%",
      align: "center",
    },
    {
      dataIndex: "port",
      title: "Port",
      key: "port",
      width: "10%",
      align: "center",
    },
    {
      dataIndex: "protocol",
      title: "Protocol",
      key: "protocol",
      width: "10%",
      align: "center",
    },
  ];

  //####################### Handle Api's######################################################

  const get_all_dcss = async () => {
    try {
      await get_device_control_system(success_dcs_list_get);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_dcs_list_get = (res) => {
    if (res?.data?.status === "success") {
      setdcsData(res?.data?.data);
    } else {
      setdcsData([]);
    }
  };

  const add_dcs = async (dcsData) => {
    try {
      await add_device_control_system(dcsData, success_add_dcs);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_add_dcs = (res) => {
    console.log(res);
    formRef.current.reset();
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      formRef.current.reset();
      set_get_status(!get_status);
      get_all_dcss();
      setdcsReq({
        name: "",
        description: "",
        ip_address: "",
        port: "",
        protocol: "",
      });
      toast.success("dcs added Successfully");
    }
  };

  useEffect(() => {
    get_all_dcss();
  }, []);

  return (
    <>
      <MainCard
        title={
          <div className="flex items-center gap-2">
            <Icons.Settings className="w-7 h-7 text-blue-600" />
            <Title level={4} style={{ color: textColor, margin: 0, padding: 0 }}>
              {t('DCS Config')}
            </Title>
          </div>
        }
      >
        {show_form && (
          <Stack direction="row" justifyContent="end">
            <Tooltip title="Close" style={{ marginTop: "-45px" }}>
              <IconButton onClick={() => set_show_form(!show_form)}>
                <CloseOutlined color="error" style={{ fontSize: "35px" }} />
              </IconButton>
            </Tooltip>
          </Stack>
        )}
        <Grid container spacing={2} columns={12} style={{ marginTop: "-15px" }}>
          {(show_form || addForm) && (
            <Grid item xs={12} lg={12}>
              <form ref={formRef} onSubmit={handleSubmit}>
                <Grid item container spacing={2} style={{ display: "flex" }}>
                  {/* Name Field */}
                  <Grid item xs={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="name">Name</InputLabel>
                      <OutlinedInput
                        id="name"
                        type="text"
                        size="small"
                        name="name"
                        placeholder="Enter Name"
                        fullWidth
                        value={dcsReq["name"]}
                        required
                        onChange={(e) =>
                          setdcsReq({
                            ...dcsReq,
                            name: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>

                  {/* Description Field */}
                  <Grid item xs={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="description">Description</InputLabel>
                      <OutlinedInput
                        id="description"
                        type="text"
                        size="small"
                        name="description"
                        placeholder="Enter Description"
                        fullWidth
                        value={dcsReq["description"]}
                        onChange={(e) =>
                          setdcsReq({
                            ...dcsReq,
                            description: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>

                  {/* IP Address Field */}
                  <Grid item xs={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="ip_address">IP Address</InputLabel>
                      <OutlinedInput
                        id="ip_address"
                        type="text"
                        size="small"
                        name="ip_address"
                        placeholder="Enter IP Address"
                        fullWidth
                        value={dcsReq["ip_address"]}
                        required
                        onChange={(e) =>
                          setdcsReq({
                            ...dcsReq,
                            ip_address: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>

                  {/* Port Field */}
                  <Grid item xs={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="port">Port</InputLabel>
                      <OutlinedInput
                        id="port"
                        type="number"
                        size="small"
                        name="port"
                        placeholder="Enter Port"
                        fullWidth
                        value={dcsReq["port"]}
                        required
                        onChange={(e) =>
                          setdcsReq({
                            ...dcsReq,
                            port: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>

                  {/* Protocol Field */}
                  <Grid item xs={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="protocol">Protocol</InputLabel>
                      <OutlinedInput
                        id="protocol"
                        type="text"
                        size="small"
                        name="protocol"
                        placeholder="Enter Protocol"
                        fullWidth
                        value={dcsReq["protocol"]}
                        required
                        onChange={(e) =>
                          setdcsReq({
                            ...dcsReq,
                            protocol: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>

                  {/* Submit and Reset Buttons */}
                  <Grid item lg={12} xs={12}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        size="small"
                        type="primary"
                        htmlType="reset"
                        className="mx-2 bg-blue-600 text-white"
                      >
                        Reset
                      </Button>
                      <Button
                        size="small"
                        type="primary"
                        htmlType="submit"
                        className="bg-blue-600 text-white"
                      >
                        Submit
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          )}
          {!show_table && (
            <Grid item xs={12} lg={12}>
              <div className="mt-3">
                <Grid item xs={12} lg={12}>
                  <Stack direction="row" spacing={1} justifyContent="end">
                    <Tooltip title="Add Machine">
                      <IconButton onClick={() => set_show_form(!show_form)}>
                        {!show_form && (
                          <PlusOutlined
                            color="primary"
                            style={{ fontSize: "35px" }}
                          />
                        )}
                      </IconButton>
                    </Tooltip>
             
                     <ReusableSearchInput
                       placeholder="Search here..."
                       width={250}
                       onSearch={(value) => setSearchvalue(value)}
                       onChange={(e) => setSearchvalue(e.target.value)}
                     />
                  </Stack>
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Table
                    dataSource={dcsData}
                    columns={dcsDetailColumns}
                    size="small"
                    bordered
                    pagination={true}
                  />
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>
      </MainCard>
    </>
  );
}

export default DcsConfig;
